import { useState } from "react";
import Link from "next/link";
import CustomSigningOfferModal from "../../components/modal/CustomSigningOfferModal";

const Header = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleNavbar = () => setIsOpen(!isOpen);
  const handleLinkClick = () => {
    if (isOpen) setIsOpen(false);
  };

  const [showCustomSigningOfferModal, setShowCustomSigningOfferModal] =
    useState(false);

  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light">
          <a href="/">
            <img
              src="/images/signowise-hu/logo.svg"
              className="logo"
              alt="logo"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
            onClick={toggleNavbar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse justify-content-end ${
              isOpen ? "show" : ""
            }`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mr-auto align-items-center">
              <Link href="#prices" className="scroll" onClick={handleLinkClick}>
                Árak
              </Link>
              <Link href="#faq" className="scroll" onClick={handleLinkClick}>
                Tudástár
              </Link>
              <button
                className="btn"
                onClick={() => setShowCustomSigningOfferModal(true)}
              >
                Érdeklődöm
              </button>
              <CustomSigningOfferModal
                showModal={showCustomSigningOfferModal}
                setShowModal={setShowCustomSigningOfferModal}
                block={props.block}
              />
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
